import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { ProfileSurveyObservationService } from '../../../service/profile-survey-observation/profile-survey-observation.service';
import { ProfileSurveyObservation } from '../../../class/profile-survey-observation';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
declare var google: any;

@Component({
  selector: 'app-profile-survey-observation',
  templateUrl: './profile-survey-observation.component.html',
  styleUrls: ['./profile-survey-observation.component.scss']
})
export class ProfileSurveyObservationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoProfileSurveyObservation: ProfileSurveyObservation;
    public profileSurvey: ProfileSurveyObservation;
    public msgs: Message[] = [];
    public options: any;
    public overlays: any[];
    public latitude: number;
    public longitude: number;
    public zoom: number;

    constructor(
        public profileSurveyService: ProfileSurveyObservationService,
        private activatedRoute: ActivatedRoute,
        private mapsAPILoader: MapsAPILoader) {
    }

    ngOnInit() {
    }

    public cancelProfileSurveyObservation () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/profile-survey-observations/profile-survey-observation/profile-survey-observation.component.ts